var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 1.01562c-.3931 0-.7862.14319-1.0722.42969l-9.48246 9.48239c-.591997.592-.591997 1.5536 0 2.1446l9.48246 9.4843c.286.286.6672.4434 1.0722.4434s.7853-.1574 1.0723-.4434l9.4844-9.4843c.592-.592.592-1.5536 0-2.1446l-9.4844-9.48239c-.2865-.2865-.6791-.42969-1.0723-.42969zm0 2.1836 8.8008 8.80078-8.8008 8.8008-8.80075-8.8008zm-4.99997 7.80078v2h2v-2zm3.99997 0v2h2v-2zm4 0v2h2v-2z",
    fill: "#000"
  })));
}
export default SvgWarningreact;